import { UI_CONFIG } from '@/lib';
import type { BadgeTone } from '@/components/ui/Badge';
import {
  MEMBERSHIP_DISPLAY_STATUS,
  type MembershipDisplayStatus,
} from './constants';

/** Badge tone for a membership display status — pairs with <Badge tone={...}>. */
export const getStatusTone = (status: MembershipDisplayStatus): BadgeTone => {
  switch (status) {
    case MEMBERSHIP_DISPLAY_STATUS.ACTIVE: return 'green';
    case MEMBERSHIP_DISPLAY_STATUS.UPCOMING: return 'blue';
    case MEMBERSHIP_DISPLAY_STATUS.EXPIRED: return 'red';
    case MEMBERSHIP_DISPLAY_STATUS.CANCELLED: return 'gray';
    default: return 'gray';
  }
};

/** @deprecated Render a <Badge tone={getStatusTone(status)}> instead. */
export const getStatusColor = (status: MembershipDisplayStatus): string => {
  switch (status) {
    case MEMBERSHIP_DISPLAY_STATUS.ACTIVE: return UI_CONFIG.STATUS_COLORS.ACTIVE;
    case MEMBERSHIP_DISPLAY_STATUS.UPCOMING: return UI_CONFIG.STATUS_COLORS.UPCOMING;
    case MEMBERSHIP_DISPLAY_STATUS.EXPIRED: return UI_CONFIG.STATUS_COLORS.EXPIRED;
    case MEMBERSHIP_DISPLAY_STATUS.CANCELLED: return UI_CONFIG.STATUS_COLORS.CANCELLED;
    default: return UI_CONFIG.STATUS_COLORS.DEFAULT;
  }
};

export const formatStatus = (status: MembershipDisplayStatus): string =>
  status.charAt(0).toUpperCase() + status.slice(1);
